import { CareTask } from 'src/store/sageAdminApi';

//careTask utilities
export const getCareTasksByResidentId = (careTasks: CareTask[]): Record<string, CareTask[]> => {
    return careTasks.reduce<Record<string, CareTask[]>>(
        (acc, careTask) => ({
            ...acc,
            [careTask.residentId]: [...(acc[careTask.residentId] ?? []), careTask],
        }),
        {}
    );
};

export const getCareTaskCountsByResidentId = (
    unresolvedCareTasks: CareTask[],
    resolvedCareTasks: CareTask[]
): Record<string, { unresolvedCount: number; resolvedCount: number }> => {
    const unresolvedByResidentId = getCareTasksByResidentId(unresolvedCareTasks);
    const resolvedByResidentId = getCareTasksByResidentId(resolvedCareTasks);

    const allResidentIds = [
        ...new Set([...unresolvedCareTasks, ...resolvedCareTasks].map((t) => t.residentId)),
    ];

    return Object.fromEntries(
        allResidentIds.map((id) => [
            id,
            {
                unresolvedCount: unresolvedByResidentId[id]?.length ?? 0,
                resolvedCount: resolvedByResidentId[id]?.length ?? 0,
            },
        ])
    );
};
